import { Component, computed, input, output } from '@angular/core';
import { GoogleAnalyticsClickEventDirective } from '@lx/shared/google-analytics';
import { ButtonComponent } from '@lx/shared/ui/button';
import { PricePipe } from '@lx/shared/ui/pipes';
import { CourseSummary } from '../../types';

@Component({
  standalone: true,
  selector: 'lx-sticky-total-price-footer',
  templateUrl: './sticky-total-price-footer.component.html',
  styleUrls: ['./sticky-total-price-footer.component.scss'],
  imports: [GoogleAnalyticsClickEventDirective, PricePipe, ButtonComponent],
})
export class StickyTotalPriceFooterComponent {
  courseSummary = input.required<CourseSummary>();
  bookNowEventName = input<string | undefined>(undefined);
  formValid = input<boolean>(false);
  onBookNow = output<void>();

  protected readonly grandTotal = computed(() => this.courseSummary().grandTotal);
  protected readonly currency = computed(() => this.courseSummary().currency);

  /**
   * Checks if price data is available
   * Returns true if grandTotal exists and has at least one price entry with a value
   */
  protected readonly priceAvailable = computed(() => {
    const total = this.grandTotal();
    return total !== undefined && total.length > 0 && total.some((price) => price.value !== undefined && price.value !== null);
  });
}
